import React from 'react';

const ConfirmationDialog = ({ isActive, onClose, onConfirm, title, message }) => {
  if (!isActive) return null;

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={onClose}></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">{title}</p>
          <button className="delete" aria-label="close" onClick={onClose}></button>
        </header>
        <section className="modal-card-body">
          <p>{message}</p>
        </section>
        <footer className="modal-card-foot">
          <button className="button is-warning" onClick={onClose}>Cancel</button>
          <button className="button is-success" onClick={onConfirm}>Yes</button>
        </footer>
      </div>
    </div>
  );
};

export default ConfirmationDialog;